import { render, staticRenderFns } from "./NewProjectGroupForm.vue?vue&type=template&id=5cca23e2&"
import script from "./NewProjectGroupForm.vue?vue&type=script&lang=js&"
export * from "./NewProjectGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports